import { cn } from '@cobliteam/colib-ui/cn';
import { Typography } from '@cobliteam/ui/components';
import type { RatingSurveyQuestion } from 'posthog-js';

interface Props {
  question: RatingSurveyQuestion;
  value?: number;
  onChange: (value: number) => void;
  hideTitle?: boolean;
}

const EMOJIS_BY_SCALE: Record<number, string[]> = {
  2: ['👎', '👍'],
  3: ['😡', '😐', '😍'],
  5: ['😡', '🙁', '😐', '🙂', '😍'],
  7: ['😡', '😠', '🙁', '😐', '🙂', '😄', '😍'],
};

const QuestionRating = ({ question, value, onChange, hideTitle = false }: Props) => {
  const { scale } = question;
  const start = scale === 10 ? 0 : 1;
  const length = scale === 10 ? 11 : scale;
  const items = Array.from({ length }, (_, i) => i + start);
  const isEmoji = question.display === 'emoji';
  const emojis = EMOJIS_BY_SCALE[scale] ?? [];

  return (
    <div className='flex flex-col gap-3'>
      {!hideTitle && (
        <Typography variant='text-md' className='font-medium'>
          {question.question}
        </Typography>
      )}
      {question.description ? <Typography variant='text-sm'>{question.description}</Typography> : null}
      <div className='flex flex-wrap gap-2' aria-label={question.question}>
        {items.map((item, idx) => {
          const selected = value === item;
          return (
            <button
              key={item}
              type='button'
              aria-pressed={selected}
              onClick={() => onChange(item)}
              className={cn(
                'flex h-10 min-w-10 items-center justify-center rounded-md border px-3 text-base transition-colors',
                selected ? 'border-primary bg-primary text-primary-foreground' : 'border-border hover:bg-muted'
              )}
            >
              {isEmoji ? (emojis[idx] ?? item) : item}
            </button>
          );
        })}
      </div>
      {question.lowerBoundLabel || question.upperBoundLabel ? (
        <div className='flex justify-between text-muted-foreground text-xs'>
          <span>{question.lowerBoundLabel}</span>
          <span>{question.upperBoundLabel}</span>
        </div>
      ) : null}
    </div>
  );
};

export default QuestionRating;
